<template lang="pug">

v-app-bar.modern-toolbar(
  flat
  height="50"
  elevation="0"
)
  .toolbar-content
    .header-left
      a.header-logo(
        v-if="!isMobile"
        href="https://www.mstimetables.ru"
      )
        .logo-icon
          v-icon(size="24" color="#334155") mdi-calendar-clock
        .logo-text
          | MSTIMETABLE

      .mobile-logo(v-else)
        v-icon(size="22" color="#334155") mdi-calendar-clock

    .header-right
      .header-site(
        v-if="siteName"
        :class="{ clickable: !!siteUrl }"
        @click="openSite"
      )
        span.site-name {{ siteName }}
        v-icon.ml-1(v-if="siteUrl" size="14" color="#64748b") mdi-external-link

</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'Toolbar',

  computed: {
    ...mapState('bootstrap', ['siteName', 'siteUrl']),

    isMobile() {
      return ['xs'].includes(this.$vuetify.breakpoint.name)
    },
  },

  methods: {
    openSite() {
      if (this.siteUrl) window.location.href = this.siteUrl
    },
  },
}
</script>

<style lang="sass" scoped>

.modern-toolbar.v-app-bar
  background: white !important
  box-shadow: 0 1px 3px rgba(0,0,0,0.1) !important
  border-bottom: 1px solid #e2e8f0
  max-height: 50px

  ::v-deep .v-toolbar__content
    padding: 0 !important

.toolbar-content
  display: flex
  align-items: center
  justify-content: space-between
  height: 50px
  max-width: 1200px
  margin: 0 auto
  padding: 0 24px
  width: 100%

.header-left
  display: flex
  align-items: center

.header-logo
  display: flex
  align-items: center
  text-decoration: none
  transition: all 0.3s ease
  touch-action: manipulation
  -webkit-tap-highlight-color: transparent

  // Hover only for devices with mouse
  @media (hover: hover)
    &:hover
      opacity: 0.8

  @media screen and (pointer: coarse)
    pointer-events: none

.logo-icon
  margin-right: 8px
  display: flex
  align-items: center
  justify-content: center

.logo-text
  color: #334155
  font-weight: 700
  font-size: 16px
  letter-spacing: 1px

.mobile-logo
  display: flex
  align-items: center
  justify-content: center

.header-right
  display: flex
  align-items: center

.header-site
  display: flex
  align-items: center
  color: #334155
  padding: 6px 12px
  border-radius: 6px
  transition: all 0.3s ease
  background: #f8fafc
  text-decoration: none
  border: 1px solid #e2e8f0
  touch-action: manipulation
  -webkit-tap-highlight-color: transparent

  &.clickable
    cursor: pointer

    // Hover only for devices with mouse
    @media (hover: hover)
      &:hover
        background: #f1f5f9

.site-name
  font-size: 14px
  font-weight: 500
  color: #334155
  overflow: hidden
  text-overflow: ellipsis
  white-space: nowrap
  max-width: 260px

// Responsive adjustments
@media (max-width: 768px)
  .toolbar-content
    padding: 0 16px

  .header-site
    padding: 6px 10px

  .site-name
    font-size: 13px

@media (max-width: 480px)
  .toolbar-content
    height: 44px !important
    padding: 0 20px

  .site-name
    font-size: 12px
    max-width: 200px
    overflow: hidden
    text-overflow: ellipsis
    white-space: nowrap

  .header-site
    padding: 4px 8px
    max-width: 220px
</style>
